<div id="content" class="allcp-form" ng-controller="RouteActivityController" ng-init="init()">
	<div ng-include="'modules/company/menus/order_menu.html'"></div>
	<div class="panel-body">
		<div class="table-responsive" ng-if="data.activities.data.length > 0">
			<table class="table table-hover tc-checkbox-1 fs13">
				<thead>
				<tr class="bg-light">
					<th class="text-left">Route ID</th>
					<th>By</th>
					<th>Activity</th>
					<th>Date</th>
				</tr>
				</thead>
				<tbody>
					<tr
						dir-paginate="item in data.activities.data | itemsPerPage: 30"
						total-items="data.activities.total"
						current-page="data.activities.current_page">
					<td class="clickable-row text-left pl20" ng-click="getOrderDetails(item.order_id)">
						{{item.route.unique_id}}
					</td>
					<td class="clickable-row">{{ item.user.full_name }} </td>
					<td>
						<span ng-if="item.status" ng-style="{'color': item.status.color }">{{ item.status.name }}</span>
						<span ng-if="!item.status">
							<span ng-if="item.transaction == 'assign_to_worker'"> Assing To Driver</span>
							<span ng-if="item.transaction == 'completed'"> Completed</span>
							<span ng-if="item.transaction == 'created'"> Created</span>
							<span ng-if="item.transaction == 'started'"> Started</span>
						</span>
					</td>
					<td>{{ item.created_at | amDateFormat:'MM/DD/YYYY, HH:mm:ss' }}</td>
				</tr>
				</tbody>
			</table>
			<dir-pagination-controls
					boundary-links="true"
					on-page-change="getPage(newPageNumber)"
					template-url="dirPagination.tpl.html"
					class="pagination-lg pagination">
				Total Record {{data.activities.total }}
			</dir-pagination-controls>
		</div>
		<div class="table-responsive" ng-if="data.activities.data.length == 0">
			<div class="alert alert-default pastel">
				<i class="fa fa-info pr10"></i>
				<strong>
					Activity Not Found!
				</strong>
			</div>
		</div>
	</div>
</div>
